/// <amd-module name="Repos/Views/FilesHub/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\files-hub\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Git from "Repos/Common/Contracts/Git";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Retrieve git commits for a project matching the search criteria
     * 
     * @param searchCriteria - Search options
     * @param repositoryId - The name or ID of the repository.
     * @param project - Project ID or project name
     * @param skip - Number of commits to skip. The value cannot exceed 3,000,000.
     * @param top - Maximum number of commits to return. The value cannot exceed 50,000.
     * @param includeStatuses - True to include additional commit status information.
     */
    getCommitsBatch(searchCriteria: Git.GitQueryCommitsCriteria, repositoryId: string, project?: string, skip?: number, top?: number, includeStatuses?: boolean): Promise<Git.GitCommitRef[]>;
    /**
     * Get file paths in a repository branch
     * 
     * @param project - Project ID or project name
     * @param repositoryId - repository identifier
     * @param scopePath - path to search under
     * @param versionDescriptor - version, version type and options
     */
    getFilePaths(project: string, repositoryId: string, scopePath?: string, versionDescriptor?: Git.GitVersionDescriptor): Promise<Git.GitFilePathsCollection>;
    /**
     * Post for retrieving a creating a batch out of a set of items in a repo / project given a list of paths or a long path
     * 
     * @param requestData - Request data attributes: ItemDescriptors, IncludeContentMetadata, LatestProcessedChange, IncludeLinks. ItemDescriptors: Collection of items to fetch, including path, version, and recursion level. IncludeContentMetadata: Whether to include metadata for all items LatestProcessedChange: Whether to include shallow ref to commit that last changed each item. IncludeLinks: Whether to include the _links field on the shallow references.
     * @param repositoryId - The name or ID of the repository
     * @param project - Project ID or project name
     */
    getItemsBatch(requestData: Git.GitItemRequestData, repositoryId: string, project?: string): Promise<Git.GitItem[][]>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Retrieve git commits for a project matching the search criteria
     * 
     * @param searchCriteria - Search options
     * @param repositoryId - The name or ID of the repository.
     * @param project - Project ID or project name
     * @param skip - Number of commits to skip. The value cannot exceed 3,000,000.
     * @param top - Maximum number of commits to return. The value cannot exceed 50,000.
     * @param includeStatuses - True to include additional commit status information.
     */
    public async getCommitsBatch(
        searchCriteria: Git.GitQueryCommitsCriteria,
        repositoryId: string,
        project?: string,
        skip?: number,
        top?: number,
        includeStatuses?: boolean
        ): Promise<Git.GitCommitRef[]> {

        const queryValues: any = {
            '$skip': skip,
            '$top': top,
            includeStatuses: includeStatuses
        };

        return this.beginRequest<Git.GitCommitRef[]>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/CommitsBatch",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            queryParams: queryValues,
            body: searchCriteria
        });
    }

    /**
     * Get file paths in a repository branch
     * 
     * @param project - Project ID or project name
     * @param repositoryId - repository identifier
     * @param scopePath - path to search under
     * @param versionDescriptor - version, version type and options
     */
    public async getFilePaths(
        project: string,
        repositoryId: string,
        scopePath?: string,
        versionDescriptor?: Git.GitVersionDescriptor
        ): Promise<Git.GitFilePathsCollection> {

        const queryValues: any = {
            scopePath: scopePath,
            versionDescriptor: versionDescriptor
        };

        return this.beginRequest<Git.GitFilePathsCollection>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/FilePaths/{*scopepath}",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            queryParams: queryValues
        });
    }

    /**
     * Post for retrieving a creating a batch out of a set of items in a repo / project given a list of paths or a long path
     * 
     * @param requestData - Request data attributes: ItemDescriptors, IncludeContentMetadata, LatestProcessedChange, IncludeLinks. ItemDescriptors: Collection of items to fetch, including path, version, and recursion level. IncludeContentMetadata: Whether to include metadata for all items LatestProcessedChange: Whether to include shallow ref to commit that last changed each item. IncludeLinks: Whether to include the _links field on the shallow references.
     * @param repositoryId - The name or ID of the repository
     * @param project - Project ID or project name
     */
    public async getItemsBatch(
        requestData: Git.GitItemRequestData,
        repositoryId: string,
        project?: string
        ): Promise<Git.GitItem[][]> {

        return this.beginRequest<Git.GitItem[][]>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/ItemsBatch",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            body: requestData
        });
    }

}

export const GitClientName = "Repos.FilesHub.Git.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
